import * as React from 'react';

import { Spacing, SpacingUnit } from 'components/ui/Spacing';
import { ArithmeticalOperatorSymbol, NewFormulaModel } from 'stores/models';

import { OperationTag } from './OperationTag';

const OPERATIONS = [
  ArithmeticalOperatorSymbol.sum,
  ArithmeticalOperatorSymbol.subtract,
  ArithmeticalOperatorSymbol.multiply,
  ArithmeticalOperatorSymbol.divide,
];

type Props = {
  formulaModel: NewFormulaModel;
};

const OperationsList: React.FC<Props> = ({ formulaModel }: Props) => {
  /** Возвращаем фокус, если кликнули на кнопку с операцией*/
  const handleOperationClick = React.useCallback(
    (operatorSymbol: ArithmeticalOperatorSymbol) => {
      formulaModel.addTextAtSelection({ text: operatorSymbol });
    },
    [formulaModel]
  );

  return (
    <Spacing.Row hSpacing={SpacingUnit.unit3}>
      {OPERATIONS.map((item) => (
        <OperationTag
          onSelect={handleOperationClick}
          key={item}
          operator={item}
        />
      ))}
    </Spacing.Row>
  );
};

export default OperationsList;
